import { Box, CircularProgress, Grid } from "@mui/material";
import React, { useContext, useState } from "react";

import { useLabels } from "api/services/useLabels";
import { LabelMapping } from "config/LabelMapping";
import { BoundingBoxesContext } from "context/boundingBoxesContext";
import { useAppDispatch } from "hooks/store";
import { setUnsavedAnnotations } from "store/slices/FocusModal/focusModalSlice";
import { ImageQuery, REVIEW_REASON_CHOICES } from "types/imageQueries";
import { isImageQueryInQueue } from "utils/imageQueriesUtils";
import { createArrayRois, mapLabels } from "utils/ReviewPageUtils";

export interface LabelButtonsProps {
  buttonLabels: Array<LabelMapping>;
  posicheckId: string;
  onLabel: () => Promise<void>;
  loadingList?: boolean;
  selectedPosicheck?: ImageQuery;
}

// @deprecated TODO: This component is deprecated. we should remove it from the code base.
export function LabelButtons(props: LabelButtonsProps) {
  const { buttonLabels, posicheckId, onLabel, loadingList: loading, selectedPosicheck } = props;

  const contextValue = useContext(BoundingBoxesContext);
  const dispatch = useAppDispatch();
  const annotations = contextValue?.annotations ?? [];
  const validBoxLabels = contextValue?.validBoxLabels;
  const stepsData = contextValue?.stepsData;

  const { createLabelAsync, isCreatingLabel } = useLabels();
  const [isLoading, setIsLoading] = useState(false);

  const onClick = async (label: string) => {
    const shouldMapLabels =
      annotations &&
      Array.isArray(validBoxLabels) &&
      validBoxLabels.length > 0 &&
      stepsData &&
      buttonLabels[0].renderedLabel !== "Confirm";
    const mappedLabels = shouldMapLabels ? mapLabels(annotations, validBoxLabels, stepsData) : null;

    const rois = mappedLabels ? createArrayRois(mappedLabels) : null;

    const detectorSupportsBoundingBoxes = contextValue?.isBoundingBoxes;

    // if the detector supports bboxes, we need to send the it as an array even if the user hasn't drawn any bboxes.
    const validRois = detectorSupportsBoundingBoxes ? rois || [] : null;

    setIsLoading(true);

    try {
      if (posicheckId) {
        await createLabelAsync({
          posicheck_id: posicheckId,
          label,
          rois: validRois,
          review_reason: REVIEW_REASON_CHOICES.CUSTOMER_INITIATED,
        });
        dispatch(setUnsavedAnnotations(false));

        if (onLabel) {
          await onLabel();
        }
      }
    } catch (error) {
      console.error("Error in onClick:", error);
      // Handle the error appropriately
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading || isCreatingLabel || loading ? (
    <Box className="mt-2 mx-auto">
      <CircularProgress size={25} />
    </Box>
  ) : (
    <>
      {buttonLabels.map((labelMapping) =>
        labelMapping.renderButton ? (
          <Grid item key={labelMapping.renderedLabel}>
            <button
              data-testid="btn-label"
              className={`cursor-pointer ${labelMapping.hoverColor} ${labelMapping.baseClass} ${labelMapping.borderColor
                } ${!isImageQueryInQueue(selectedPosicheck)
                  ? `${labelMapping.baseColor}`
                  : `${labelMapping.textColor} bg-white`
                }`}
              type="button"
              onClick={() => onClick(labelMapping.backendLabel)}
            >
              {labelMapping.renderedLabel}
            </button>
          </Grid>
        ) : undefined
      )}
    </>
  );
}
